module.exports = __webpack_public_path__ + "static/media/gimlet.b8774451.svg";